import React from "react"
const SubmitContext= React.createContext({});

export default SubmitContext;